import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import IngestService from "./IngestService";
import AgentGuardian from "./AgentGuardian";
import AgentWikiOnThisDay from "./AgentWikiOnThisDay";
import AgentNasaApod from "./AgentNasaApod";
import AgentWikinews from "./AgentWikinews";
import AgentGoogleBook from "./AgentGoogleBook";

const IngestMain = () => {
    const [loading, setLoading] = useState(false);
    const [setting, setSetting] = useState(null);
    const [wikipediaSetting, setWikipediaSetting] = useState(null);
    const [nasaSetting, setNasaSetting] = useState(null);
    const [googleBookSetting, setGoogleBookSetting] = useState(null);

    const fetchAllSettings = async () => {
        setLoading(true);

        const result = await IngestService.fetchAllSettings();

        if (result.success && result.data.settings) {
            // Extract ingest_date setting
            const ingestDateSetting = result.data.settings.find(s => s.key === "ingest_date");
            if (ingestDateSetting) {
                setSetting(ingestDateSetting);
            }

            // Extract wiki_onthisday_date setting
            const wikipediaDateSetting = result.data.settings.find(s => s.key === "wiki_onthisday_date");
            if (wikipediaDateSetting) {
                setWikipediaSetting(wikipediaDateSetting);
            }

            // Extract nasa_apod_date setting
            const nasaDateSetting = result.data.settings.find(s => s.key === "nasa_apod_date");
            if (nasaDateSetting) {
                setNasaSetting(nasaDateSetting);
            }

            // Extract googlebook_start_index setting
            const googleBookIndexSetting = result.data.settings.find(s => s.key === "googlebook_start_index");
            if (googleBookIndexSetting) {
                setGoogleBookSetting(googleBookIndexSetting);
            }
        }

        setLoading(false);
    };


    useEffect(() => {
        fetchAllSettings();
    }, []);

    return (
        <Box sx={{ flexGrow: 1, p: 0 }}>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                        <AgentGuardian setting={setting} onRefresh={fetchAllSettings} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                        <AgentNasaApod setting={nasaSetting} onRefresh={fetchAllSettings} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                        <AgentWikiOnThisDay setting={wikipediaSetting} onRefresh={fetchAllSettings} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                        <AgentWikinews />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                        <AgentGoogleBook setting={googleBookSetting} onRefresh={fetchAllSettings} />
                    </Grid>
                </Grid>
            )}
        </Box>
    );
};

export default IngestMain;

